const AddedByAPIEnum = {
  GREENSKY: { value: 'G', name: 'Greensky' },
  ESS: { value: 'E', name: 'ESS' },
  CUSTOMFIN: { value: 'C', name: 'CustomFin' },
  SERVICEFINANCE: { value: 'S', name: 'ServiceFinance' },
  FTL: { value: 'F', name: 'FTL' },
};

export default AddedByAPIEnum;
